module.exports = __webpack_public_path__ + "static/media/director2.21f0e245.5,cg_true";